export const deliveryOptions = [
  { value: 0, label: "kg Rohhopfen" },
  { value: 1, label: "kg Alpha" },
];
